exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".course_list_item a {\n  color: #686F7A;\n  font-size: 13px;\n  line-height: 1.43;\n}\n.course_list_item .pop__course_title h1 {\n  font-size: 18px;\n  font-weight: 500;\n  line-height: 1.43em;\n  color: #29303B;\n  padding: 0;\n}\n.course_list_item .pop__course_title {\n  color: #29303B;\n  font-size: 15px;\n  letter-spacing: -0.25px;\n  line-height: 18px;\n  font-weight: 600;\n  margin-top: 19px;\n  margin-left: 9px;\n}\n.course_list_item .pop__course_what_you_learn {\n  color: #686F7A;\n}", ""]);

// exports
